module.exports = __webpack_public_path__ + "img/sport.50dd7696.svg";